import api from './index';

export const getCoins = () => api.get('coins').then((response) => response.data.coins);
